import { type FieldValues, type FormState, type Path, type UseFormRegister } from "react-hook-form";

import { Input, type InputProps } from "@fronterahealth/frontera-ui-components/Input/Input";

export interface FormInputProps<T extends FieldValues> extends Omit<InputProps, "name" | "pattern" | "ref" | "label"> {
  label?: string;
  register: UseFormRegister<T>;
  formState: FormState<T>;
  formKey: Path<T>;
  required?: boolean;
  pattern?: RegExp;
  patternMessage?: string;
}

export const FormInput = <T extends FieldValues>({
  formState,
  formKey,
  register,
  label,
  required = true,
  pattern,
  patternMessage,
  ...props
}: FormInputProps<T>) => {
  const errorMessage = formState.errors[formKey]?.message?.toString() ?? "";

  return (
    <Input
      label={label ?? ""}
      hintText={required ? undefined : "Optional"}
      inputSize="full"
      errorMessage={errorMessage}
      {...register(formKey, {
        required: required ? `${label} is required` : false,
        pattern: pattern
          ? { value: pattern, message: patternMessage ?? `${label} must match pattern above` }
          : undefined,
      })}
      {...props}
    />
  );
};
